import { render } from "./App.vue?vue&type=template&id=5c924755"
const script = {}

const cssModules = {}
import style0 from "./App.vue?vue&type=style&index=0&id=5c924755&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__